import '../css/main.css';
import { initAnalytics, track } from './analytics.js';
import { MarketplaceFilter } from './marketplace-filter.js';

// Expose track globally for inline onclick handlers in PHP templates
window.track = track;

document.addEventListener('DOMContentLoaded', () => {
  initAnalytics(window.hubstaffSettings?.segmentWriteKey);

  // Initialize marketplace filter
  const marketplace = document.querySelector('[data-marketplace]');
  if (marketplace) {
    new MarketplaceFilter(marketplace);
  }

  // Mobile categories dropdown
  const mobileCategoriesToggle = document.getElementById('mobile-categories-toggle');
  const mobileCategoriesList = document.getElementById('mobile-categories-list');
  const mobileCategoriesChevron = document.getElementById('mobile-categories-chevron');

  if (mobileCategoriesToggle && mobileCategoriesList) {
    mobileCategoriesToggle.addEventListener('click', () => {
      const isExpanded = mobileCategoriesToggle.getAttribute('aria-expanded') === 'true';
      mobileCategoriesList.classList.toggle('hidden');
      mobileCategoriesChevron.style.transform = isExpanded ? '' : 'rotate(180deg)';
      mobileCategoriesToggle.setAttribute('aria-expanded', !isExpanded);
    });

    // Close dropdown when a category is selected
    mobileCategoriesList.querySelectorAll('[data-filter-category]').forEach(btn => {
      btn.addEventListener('click', () => {
        mobileCategoriesList.classList.add('hidden');
        mobileCategoriesChevron.style.transform = '';
        mobileCategoriesToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Mobile menu toggle
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const hamburgerIcon = document.getElementById('hamburger-icon');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      const isExpanded = mobileMenuToggle.getAttribute('aria-expanded') === 'true';

      // Toggle menu visibility
      mobileMenu.classList.toggle('hidden');

      // Animate hamburger to X
      hamburgerIcon.classList.toggle('hamburger-icon--open');

      // Lock/unlock body scroll
      document.body.classList.toggle('overflow-hidden', isExpanded === false);

      // Update aria-expanded
      mobileMenuToggle.setAttribute('aria-expanded', !isExpanded);
    });
  }
});
